import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import Rooms from '@/views/Rooms'
import Room from '@/views/Room'
import Rates from '@/views/Rates'
import Bookings from '@/views/Bookings'
import Contact from '@/views/Contact'
import Discover from '@/views/Discover'
import GuestsBook from '@/views/GuestsBook'
import Gallery from '@/views/Gallery'
import Conditions from '@/views/Conditions'
import Reviews from '@/views/Reviews'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/rooms',
    name: 'Rooms',
    component: Rooms
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: Gallery
  },
  {
    path: '/room',
    name: 'room',
    component: Room
  },
  {
    path: '/rates',
    name: 'Rates',
    component: Rates
  },
  {
    path: '/bookings',
    name: 'Bookings',
    component: Bookings
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Conditions
  },
  {
    path: '/discover',
    name: 'Discover',
    component: Discover
  },
  {
    path: '/guestsbook',
    name: 'GuestsBook',
    component: GuestsBook
  },
  {
    path: '/reviews',
    name: 'Reviews',
    component: Reviews
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

export default router
